import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { libLang } from '../../app.component';

@Pipe({
  name: 'momentFormat',
})
export class MomentFormatPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(
    date: string | Date,
    format = 'DD MMM YYYY',
    lang: string = this.translate.currentLang
  ): string {
    moment.locale(libLang.moment[lang]);
    return moment(date).format(format);
  }
}
